import React, { Component } from "react";
import Fases from "../../components/results/Fases";
import { getMatchProgressContribution } from "../../util/MatchProgressFasesLogic";

class FasesContainer extends Component {
  render() {
    let fasesPerDivision = {};
    let matches = this.props.matches;
    for (let m in matches) {
      const match = matches[m];
      const poule = this.props.poulesByKey[match.poule];
      if (poule) {
        if (fasesPerDivision[poule.division] === undefined) {
          fasesPerDivision[poule.division] = {};
        }
        if (fasesPerDivision[poule.division][poule.fase] === undefined) {
          fasesPerDivision[poule.division][poule.fase] = {
            played: 0,
            total: 0,
          };
        }
        const { countScheduled, countPlayed } = getMatchProgressContribution(
          match,
          poule,
          this.props.bracketsByKey,
          this.props.tournament,
        );
        if (countScheduled) {
          fasesPerDivision[poule.division][poule.fase].total++;
        }
        if (countPlayed) {
          fasesPerDivision[poule.division][poule.fase].played++;
        }
      }
    }
    // console.log(fasesPerDivision);
    return <Fases {...this.props} fasesPerDivision={fasesPerDivision} />;
  }
}

export default FasesContainer;
